import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { Guard } from '../../components/layout/Guard';

const MonthEndPage = lazy(() => import('./MonthEndPage'));

const routes: RouteObject[] = [
  { path: '/periods', element: <Guard any={['period.read']}><MonthEndPage /></Guard> },
  // approval links for reopen requests (REO-...) arrive as /periods/<request number>
  { path: '/periods/:ref', element: <Guard any={['period.read']}><MonthEndPage /></Guard> },
];
export default routes;
